/** Helpers for TITAN_EQUITIES_ONLY / stocks-focus UI filtering. */

const STOCK_CLASSES = new Set(['stocks', 'stock', 'equity', 'equities']);

export function isStockAssetClass(assetClass?: string | null): boolean {
  const ac = (assetClass || 'stocks').toLowerCase();
  return STOCK_CLASSES.has(ac);
}

export function filterStockPositions<T extends { asset_class?: string }>(
  positions: T[],
  equitiesOnly: boolean,
): T[] {
  if (!equitiesOnly) return positions;
  return positions.filter((p) => isStockAssetClass(p.asset_class));
}

export function filterStockPatterns<T extends { asset_class?: string }>(
  patterns: T[],
  equitiesOnly: boolean,
): T[] {
  if (!equitiesOnly) return patterns;
  return patterns.filter((p) => isStockAssetClass(p.asset_class));
}
